import React, { useState, useEffect, FormEvent } from 'react';
import { FileInput, ProgressBar, Checkbox } from "@blueprintjs/core";
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Alert } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { AxiosInstance } from 'axios';
import * as utils from "./utils";

import "./Import.scss"

import svgWait1 from './svg/wait1.svg'
import svgWait2 from './svg/wait2.gif'

import { SystemHeader } from './CommonUI';

interface ImportMainProps {
    gsb: AxiosInstance
}

interface FileInfo {
    fileName: string,
    select: string,
    size: number,
    type: string,
    contentDate: string,
    records: number,
    error: string,
    delete: string,
    clear: string
}

interface TaskInfo {
    id: string,
    ref: string,
    description: string,
    startTime: string,
    endTime: string,
    userId: string,
    progressValue: number,
    progressMax: number,
    status: number,
    message: string,
    logFile: string
}


var GsbFlag: any;

function ImportMain({ gsb }: ImportMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [showButton, setshowButton] = useState(true)
    const [CanSkipWarning, setCanSkipWarning] = useState("0")

    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")
    const [isShowAlert3, setisShowAlert3] = useState(false)
    const [ShowAlert3Msg, setShowAlert3Msg] = useState([])
    const [isShowAlert4, setisShowAlert4] = useState(false)
    const [ShowAlert4Msg, setShowAlert4Msg] = useState([])

    const [fileInfoList, setFileInfoList] = useState([] as FileInfo[])
    const [file1Label, setFile1Label] = useState("Choose file...")
    const [file2Label, setFile2Label] = useState("Choose file...")
    const [file3Label, setFile3Label] = useState("Choose file...")
    const [file4Label, setFile4Label] = useState("Choose file...")
    const [file5Label, setFile5Label] = useState("Choose file...")
    const [uploadStatus, setUploadStatus] = useState("")
    const [uploadProgress, setUploadProgress] = useState(0)

    const [taskList, setTaskList] = useState([] as TaskInfo[])
    const [showTasks, setShowTasks] = useState(false)

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [Enter2tab, setEnter2tab] = useState("Y")

    const [SAS_MKT, setSAS_MKT] = useState(false)
    const [SYNC_TEXT, setSYNC_TEXT] = useState(false)
    const [IMP_INET, setIMP_INET] = useState(false)
    const [AMS3_MWS, setAMS3_MWS] = useState(false)
    const [IMP_PRDW_CSV, setIMP_PRDW_CSV] = useState(false)

    const [GSBx_USER, setGSBx_USER] = useState(false)
    const [FBSx_USER, setFBSx_USER] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setEnter2tab(GsbFlag.Enter2tab) ;

                setSAS_MKT(GsbFlag.SAS_MKT)
                setIMP_INET(GsbFlag.IMP_INET)
                setSYNC_TEXT(GsbFlag.SYNC_TEXT)
                setAMS3_MWS(GsbFlag.AMS3_MWS)
                setIMP_PRDW_CSV(GsbFlag.IMP_PRDW_CSV)

                setGSBx_USER(GsbFlag.GSBx_USER)
                setFBSx_USER(GsbFlag.FBSx_USER)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    
    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])


    useEffect(() => {
        (async () => {
            try {
                const res = await gsb.post('/import',
                {   sb_data: {
                        
                    },
                    cPgmId: "importlist",
                });                
                //console.log("importlist res.data.data", res.data.data);
                setFileInfoList(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        if (taskList.findIndex((t: TaskInfo) => t.status === 0) > -1) {
            //console.log("running task(s) found, refresh tasklist in 1s")
            setTimeout(async () => {
                try {
                    const res = await gsb.post('/tasklist', taskList.map((t) => t.id));
                    setTaskList(res.data.data)
                } catch (error) {
                    utils.showError(error)
                }
            }, 3+1000)
        } else {
            //console.log("all task(s) completed.")
        }
    }, [taskList, gsb])

    const onSubmit = (e: FormEvent) => {
        e.preventDefault();

        (async () => {
            try {
                setUploadProgress(0);
                setUploadStatus("Uploading...");
                const res = await gsb.post('/importupload',
                    new FormData(e.target as HTMLFormElement),
                    {
                        onUploadProgress: (progressEvent) => {
                            const progress = progressEvent!.loaded / progressEvent!.total!;
                            setUploadProgress(progress)
                            if (progress == 1) {
                                setUploadStatus("Waiting for completion...")
                            }
                            // console.log(`Upload Progress: ${progress}%`);
                        },
                    }
                );
                setUploadStatus("Done.")
                utils.showSuccess(`${res.data.uploaded} file(s) uploaded`)
                setFileInfoList(res.data.data)
                if (res.data.Prompt_Msg.isShowMsg) {
                    setisShowAlert3(true)
                    setShowAlert3Msg(res.data.Prompt_Msg.MsgShow)
                } else if (res.data.Warning_Msg.isShowMsg) {
                    setisShowAlert4(true)
                    setShowAlert4Msg(res.data.Warning_Msg.MsgShow)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    const onImportFiles = () => {
        //console.log("onImportFiles fileInfoList", fileInfoList);
        (async () => {
            try {
                const res = await gsb.post('/import',
                    {   sb_data: {
                        fileInfoList: fileInfoList
                    },
                    cPgmId: "importfiles",
                });                
                setTaskList(res.data.data)
                setShowTasks(true)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }

    const onSelectfile = (fileName: string) => {
        if (fileName.length > 0 ) {
            //console.log("onSelectfile fileName", fileName);
            //console.log("onSelectfile fileInfoList", fileInfoList);
            let newfileInfoList = [...fileInfoList]

            for (let j = 0; j < newfileInfoList.length; j++) {
                if ( newfileInfoList[j].fileName == fileName ) {
                    if ( newfileInfoList[j].select == "Y" ) {
                        newfileInfoList[j].select = "N"
                    } else {
                        newfileInfoList[j].select = "Y"
                    }
                    break
                }
            }
            setFileInfoList(newfileInfoList);
        }
    }

    const onClearfile = (fileName: string) => {
        if (fileName.length > 0 ) {
            //console.log("onClearfile fileName", fileName);
            console.log("onClearfile fileInfoList", fileInfoList);

            for (let j = 0; j < fileInfoList.length; j++) {
                if ( fileInfoList[j].fileName == fileName ) {
                    if ( fileInfoList[j].clear == "Y" ) {
                        fileInfoList[j].clear = "N"
                    } else if ( fileInfoList[j].clear == "N" ) {
                        fileInfoList[j].clear = "Y"
                    }
                    break
                }
            }
        }
    }

    const onDeletefile = (fileName: string) => {
        if (fileName.length > 0 ) {
//            console.log("onDeletefile fileName", fileName);
            (async () => {
                try {
                    const res = await gsb.post('/import',
                        {   sb_data: {
                        filename: fileName   
                        },
                        cPgmId: "deletefile",
                    });                
                    setFileInfoList(res.data.data)
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>
            <div className="Spacing-V-Menu"></div>
            <div className="Row">
                <FormGroup className="Col-1-12"  >
                    {CoHead}
                </FormGroup>
            </div>            
            <p><H3>Import Files</H3></p>
            <HTMLTable striped interactive condensed>
                <thead>
                    <th className="TCol-FileName">File Name</th>
                    <th className="TCol-FileSelect">Select</th>
                    <th className="TCol-FileType">Type</th>
                    <th className="TCol-Date">Content Date</th>
                    <th className="TCol-Records"><div className="Align-R">Records</div></th>
                    <th className="TCol-Error">Error</th>
                    {/*<th className="TCol-Clear">Clear Previous Imported</th>*/}
                    <th className="TCol-Delete">Delete</th>
                </thead>
                <tbody>
                    {fileInfoList.map((f, i) =>
                        <tr key={i}>
                            <td className="TCol-FileName">{f.fileName}</td>
                            <td className="TCol-FileSelect"><Checkbox checked={f.select=="Y"} onChange={() => onSelectfile(f.fileName)} /></td>
                            <td className="TCol-FileType">{f.type}</td>
                            <td className="TCol-Date">{f.contentDate}</td>
                            <td className="TCol-Records"><div className="Align-R">{utils.formatNumber(f.records)}</div></td>
                            <td className="TCol-Error">{f.error}</td>
                            {/*<td className="TCol-Clear">{!(f.clear=="") && <Checkbox label="Clear" onChange={() => onClearfile(f.fileName)} /> }</td>*/}
                            <td className="TCol-Delete"><Button icon="delete" onClick={() => onDeletefile(f.fileName)} >Delete</Button></td>
                        </tr>
                    )}
                </tbody>
            </HTMLTable>
            <div className="Spacing-V-8"></div>
            <div className="Row">
                <Button className="Col-1-1" icon={IconNames.IMPORT} onClick={onImportFiles}>Import</Button>
                <Button className="Col-2-1" icon={IconNames.LIST} onClick={() => setShowTasks(!showTasks)}>Tasks</Button>
            </div>
            <div className="Spacing-V-16"></div>
            <Collapse isOpen={showTasks}>
                <p>Tasks</p>
                <HTMLTable striped interactive condensed>
                    <thead>
                        <th className="TCol-Ref">File Name</th>
                        <th className="TCol-Progress">Progress</th>
                        <th className="TCol-Message">Message</th>
                        <th className="TCol-Log">Log</th>
                    </thead>
                    <tbody>
                        {taskList.map((t, i) =>
                            <tr key={i}>
                                <td className="TCol-Ref">{t.ref}</td>
                                <td className="TCol-Progress"><ProgressBar stripes={false} animate={false} value={t.progressValue / t.progressMax} /></td>
                                <td className="TCol-Message">{t.message}</td>
                                <td className="TCol-Log">{t.logFile && <a key={i} target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${t.logFile}&inline`}>View</a>}</td>
                            </tr>
                        )}
                    </tbody>
                </HTMLTable>
                {/*
                <div className="Spacing-V-8"></div>
                <div className="Row">
                    <Button className="Col-1-1" type="submit" icon={IconNames.CROSS} onClick={() => setShowTasks(!showTasks)}>Tasks</Button>
                </div>
                */}
                <div className="Spacing-V-16"></div>
            </Collapse>
            <p>Upload Files</p>
            <form className="Import" onSubmit={onSubmit}>
                <div className="Row">
                    <FileInput className="Col-1-3" inputProps={{ name: "file1" }} text={file1Label} onInputChange={utils.handleStringChange((s) => setFile1Label(utils.fileBase(s)))} />
                </div>
                <div className="Row">
                    <FileInput className="Col-1-3" inputProps={{ name: "file2" }} text={file2Label} onInputChange={utils.handleStringChange((s) => setFile2Label(utils.fileBase(s)))} />
                </div>
                <div className="Row">
                    <FileInput className="Col-1-3" inputProps={{ name: "file3" }} text={file3Label} onInputChange={utils.handleStringChange((s) => setFile3Label(utils.fileBase(s)))} />
                </div>
                <div className="Row">
                    <FileInput className="Col-1-3" inputProps={{ name: "file4" }} text={file4Label} onInputChange={utils.handleStringChange((s) => setFile4Label(utils.fileBase(s)))} />
                </div>
                <div className="Row">
                    <FileInput className="Col-1-3" inputProps={{ name: "file5" }} text={file5Label} onInputChange={utils.handleStringChange((s) => setFile5Label(utils.fileBase(s)))} />
                </div>
                <div className="Spacing-V-8"></div>
                <div className="Row">
                    <Button className="Col-1-1" type="submit" icon={IconNames.UPLOAD}>Upload</Button>
                </div>
                {uploadStatus !== "" && <>
                    <div className="Spacing-V-16"></div>
                    <div className="Row">
                        <div className="Col-1-3">{uploadStatus}</div>
                    </div>
                    <div className="Row">
                        <ProgressBar className="Col-1-3" stripes={false} animate={false} value={uploadProgress} />
                    </div>
                </>}
            </form>
            <br></br>
            <p>Notes</p>
            <div>
                <div>Trades</div>
                { SYNC_TEXT && <div>31R Real-Time Data Exchange -- Trade Import, file name: FEBSTRAN.txt</div> }
                { IMP_INET && <div>Client Trading Text File (Standard), file name: 31I_yyyymmdd.txt</div> }
                { AMS3_MWS && <div>Client Trading File From AMS3-MWS , file name: MWyymmdd</div> }
                { FBSx_USER && <div>SPSystem Trade File, file name: SPLyymmdd.txt</div> }
                <div><br></br></div>
                { GSBx_USER && <div>32M HK Stock AMS/3-MWS TEXT FILE FROM SEHK, file name: yyyymmdd.ctf or ctfddmmm.dat</div> }
                { SAS_MKT && <div>SAS/SZMK Market Stock AMS/3-MWS TEXT FILE FROM SEHK, file name: yyyymmddashr.ctf</div> }
                { GSBx_USER && <div>323 CAPTURE TRANSACTION TEXT FILE FROM SEHK, file name: 323_yyyymmdd.txt</div> }
                { FBSx_USER && <div>HKFE Position Details CSV (TP001), file name: yyyymmdd.raw</div> }
                <div><br></br></div>
                <div>Closing Price</div>
                { GSBx_USER && <div>HK Stock Closing Price, file name: yyyymmdd.cp or ctfclospric</div> }
                { GSBx_USER && SAS_MKT && <div>Shanghai Stock Closing Price, file name: asclospric</div> }
                { GSBx_USER && SAS_MKT && <div>Shenzhen Stock Closing Price, file name: szclospric</div> }
                { FBSx_USER && <div>HKFE Series Prices CSV (RP006), file name: yyyymmdd_1_rp006-final_f.raw</div> }
                <div><br></br></div>
                { IMP_INET && <div>P/R Transaction Text File (Standard), file name: 33I_yyyymmdd.txt</div> }
                { IMP_PRDW_CSV && <div>P/R Transaction CSV File, file name: 33_yyyymmdd.csv</div> }
                { IMP_INET && <div>D/W Transaction Text File (Standard), file name: 34I_yyyymmdd.txt</div> }
                { IMP_PRDW_CSV && <div>D/W Transaction CSV File, file name: 34_yyyymmdd.csv</div> }
            </div >

            <div className="Spacing-V-16"></div>
                <Alert
                    confirmButtonText="OK"
                    icon="tick-circle"
                    intent={Intent.SUCCESS}
                    isOpen={isShowAlert1}
                    onCancel={ () => setisShowAlert1(false) }
                    onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                >
                    <p>
                        {ShowAlert1Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.DANGER}
                    isOpen={isShowAlert2}
                    onCancel={ () => setisShowAlert2(false) }
                    onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                >
                    <p>
                        {ShowAlert2Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.DANGER}
                    isOpen={isShowAlert3}
                    onCancel={ () => setisShowAlert3(false) }
                    onConfirm={ () => { setShowAlert3Msg([]); setisShowAlert3(false) } }
                >
                    <p>
                        {/*ShowAlert3Msg*/}
                        <div className="Spacing-V-16"></div>
                        {ShowAlert3Msg.map((Wmsg, j) => 
                            <div>{ShowAlert3Msg[j]}</div>
                        )}
                    </p>
                </Alert>
                <Alert
                    cancelButtonText="No"
                    confirmButtonText="Yes"
                    icon="warning-sign"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert4}
                    onCancel={ () => { setCanSkipWarning("1"); setshowButton(false); setisShowAlert4(false) } }
                    onConfirm={ () => { setCanSkipWarning("2"); setshowButton(true); setShowAlert4Msg([]); setisShowAlert4(false) } }
                >
                    <p>
                        {/*ShowAlert4Msg*/}
                        <div className="Spacing-V-16"></div>
                        {ShowAlert4Msg.map((Wmsg, j) => 
                            <div>{ShowAlert4Msg[j]}</div>
                        )}

                    </p>
                </Alert>
        </>
    )
}

export default ImportMain